import React, { FC, forwardRef } from 'react';
import { SvgIconProps } from '@material-ui/core';
import CatalogFacetArrowSvg from './catalog-facet-arrow.svg';
import CatalogSelectArrowSvg from './catalog-select-arrow.svg';
import CatalogCartSvg from './catalog-cart.svg';
import CatalogRemoveSvg from './catalog-remove.svg';

export const CatalogFacetArrowIcon: FC<SvgIconProps> = forwardRef((props, ref) => (
  <CatalogFacetArrowSvg ref={ref} {...props} />
));

export const CatalogSelectArrowIcon: FC<SvgIconProps> = forwardRef((props, ref) => (
  <CatalogSelectArrowSvg ref={ref} {...props} />
));

export const CatalogCartIcon: FC<SvgIconProps> = forwardRef((props, ref) => (
  <CatalogCartSvg ref={ref} {...props} />
));

export const CatalogRemoveIcon: FC<SvgIconProps> = forwardRef((props, ref) => (
  <CatalogRemoveSvg ref={ref} {...props} />
));
